import { render } from "./PdfPreviewer.vue?vue&type=template&id=461fd4d7"
import script from "./PdfPreviewer.vue?vue&type=script&lang=js"
export * from "./PdfPreviewer.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__